import { render } from "./BillingHome.vue?vue&type=template&id=125d53ca&scoped=true"
import script from "./BillingHome.vue?vue&type=script&lang=js"
export * from "./BillingHome.vue?vue&type=script&lang=js"

import "./BillingHome.vue?vue&type=style&index=0&id=125d53ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125d53ca"]])

export default __exports__